import React from 'react';
import formatMission from "../../utils/formatMission";
import { Container } from './styles';

const MissionDetails = ({ mission }) => {

    return (
        <Container>
            <div id="mission">
                <div id="title">
                    <div className="wrapper">
                        <div className="mission-label">Título</div>
                        <div className="mission-value">{mission.title}</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Descrição</div>
                        <div className="mission-value">{mission.description}</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Duração</div>
                        <div className="mission-value">{mission.duration} dias</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Recomenção à criança</div>
                        <div className="mission-value">{mission.recommendationChild}</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Recomendação aos pais</div>
                        <div className="mission-value">{mission.recommendationParent}</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Pontos</div>
                        <div className="mission-value">{mission.score}</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Habilidade</div>
                        <div className="mission-value">{mission.skill}</div>
                    </div>
                    <div className="wrapper">
                        <div className="mission-label">Objetivo</div>
                        <div className="mission-value">{formatMission(mission.goals)}</div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default MissionDetails;